import { useTranslation } from 'react-i18next';
import ReminderHeaderBell from './ReminderHeaderBell';

interface TaskHallHeaderProps {
  taskCount: number;
}

function TaskHallHeader({ taskCount }: TaskHallHeaderProps) {
  const { t } = useTranslation();

  return (
    <header className="driver-hall-header">
      <div className="driver-hall-header__title-row">
        <h1 className="driver-hall-header__title">{t('hall.title')}</h1>
        <span className="driver-hall-header__count">{taskCount}</span>
      </div>
      <ReminderHeaderBell variant="onPrimary" />
    </header>
  );
}

export default TaskHallHeader;
